import {css, useTheme} from '@mui/material';
import {DlMuiCheckIcon, DlMuiChip, GetStylesFunction} from '@wallaby-ui/core';
import * as React from 'react';
import {DocumentColors} from 'src/js/common';

type Props = {
  id: string;
  label: string;
  selected: boolean;
  onClick: (id: string) => void;
  colors: DocumentColors;
};

export const DlMuiTag: React.FC<Props> = (props) => {
  const {id, label, selected, onClick, colors} = props;
  const theme = useTheme();
  const styles = getStyles({theme});
  const {highlight = '#fff', background = '#fff'} = colors;
  return (
    <DlMuiChip
      inputCss={styles.dlMuiChip}
      style={{
        backgroundColor: background,
        border: `1px solid ${highlight}`,
        color: '#012b30',
      }}
      onClick={() => onClick(id)}
      label={label}
      title={label}
      icon={
        <DlMuiCheckIcon
          style={{
            color: selected ? '#121619' : '#12161933',
            maxHeight: 'unset',
          }}
        />
      }
    />
  );
};

DlMuiTag.displayName = 'DlMuiTag';

const getStyles: GetStylesFunction = (options) => ({
  wrapper: css`
    background-color: ${options?.theme?.palette.custom.coolGray['50']};
    gap: ${options?.theme?.spacing(3)};
    display: flex;
    flex-direction: column;
    padding: ${options?.theme?.spacing(4)};
    align-items: flex-start;
    align-self: stretch;
    border-radius: ${options?.theme?.spacing(6)};
    overflow: hidden;
  `,
  dlMuiChip: css`
    margin-right: 4px;
    .MuiChip-label {
      max-height: unset;
    }
  `,
});
